module.exports = __webpack_public_path__ + "static/media/groveicon.1b040297.png";